import { Outlet } from 'react-router-dom'

const Master = () => <Outlet />

export default Master
